<template>
  <div style="padding: 30px 0">
    <a-row type="flex" justify="space-between" style="margin-bottom:15px">
      <a-col>
        <a-row type="flex" align="middle" :gutter="15">
          <a-col>
            <span style="height:25px;border-left:3px solid #35B5FE;"></span>
          </a-col>
          <a-col>
            <b>软性点评</b>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-row type="flex">
      <a-col span="24" style="padding:0 20px">
        <a-list itemLayout="vertical">
          <div
            v-if="showSoftLoadingMore"
            slot="loadMore"
            :style="{
              textAlign: 'center',
              marginTop: '12px',
              height: '32px',
              lineHeight: '32px'
            }"
          >
            <a-spin v-if="softLoadingMore" />
            <a-button v-else @click="getSoftList()">加载更多</a-button>
          </div>

          <a-list-item v-for="item in softList" :key="item.id">
            <a-list-item-meta :description="'添加时间：' + item.created_at" :title="resume.name"></a-list-item-meta>
            <p style="padding-top:8px;">
              <b style="margin-right:20px;">极端外貌评价</b>
              <template v-for="extra in item.extra">
                <a-button
                  :key="extra"
                  disabled
                  style="cursor:default;background-color:#e6f1fc;color: #1989fa;margin-left:12px"
                >{{ extra }}</a-button>
              </template>
            </p>
            <div slot="extra" style="min-width:200px;">
              <b style="margin:20px 0 10px;display:block">软性评价</b>
              <template v-for="(soft, index) in item.soft">
                <div :key="index">{{ soft }}</div>
              </template>
            </div>
          </a-list-item>
        </a-list>
      </a-col>
    </a-row>
    <a-divider></a-divider>
    <a-row type="flex" justify="space-between" style="margin-bottom:15px">
      <a-col>
        <a-row type="flex" align="middle" :gutter="15">
          <a-col>
            <span style="height:25px;border-left:3px solid #35B5FE;"></span>
          </a-col>
          <a-col>
            <b>沟通记录</b>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-row type="flex">
      <a-col span="24" style="padding:0 20px">
        <a-list itemLayout="vertical">
          <div
            v-if="showComLoadingMore"
            slot="loadMore"
            :style="{
              textAlign: 'center',
              marginTop: '12px',
              height: '32px',
              lineHeight: '32px'
            }"
          >
            <a-spin v-if="comLoadingMore" />
            <a-button v-else @click="getCommunicationList()">加载更多</a-button>
          </div>

          <a-list-item v-for="item in communicationList" :key="item.id">
            <a-list-item-meta :description="'添加时间：' + item.created_at" title="来自HR的沟通"></a-list-item-meta>
            <p>{{ item.content }}</p>
          </a-list-item>
        </a-list>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import Api from "@/api";
import { async } from "q";
import baseComponentVue from "@/components/base-component.vue";
export default {
  name: "Contact",
  extends: baseComponentVue,
  props: ["resume", "id"],
  data() {
    return {
      showSoftLoadingMore: false,
      softLoadingMore: false,
      softPage: 0,
      showComLoadingMore: false,
      comLoadingMore: false,
      comPage: 0,
      softList: [],
      communicationList: []
    };
  },
  created() {
    this.getSoftList();
    this.getCommunicationList();
  },
  methods: {
    async getCommunicationList() {
      this.comLoadingMore = true;
      let resume_id = this.resume.id;
      this.comPage = this.comPage + 1;
      let params = {
        page: this.comPage,
        limit: 3,
        resume_id
      };
      let {
        list: communicationList,
        total
      } = await Api.resume.getCommunicationList(params);
      this.comLoadingMore = false;
      this.communicationList = [
        ...this.communicationList,
        ...communicationList
      ];
      this.showComLoadingMore = total > this.comPage * 3 ? true : false;
    },
    async updateCommunication() {
      this.comLoadingMore = true;
      let { list: communicationList } = await Api.resume.getCommunicationList({
        page: 1,
        limit: 1,
        resume_id: this.resume.id
      });
      this.comLoadingMore = false;
      this.communicationList = [
        ...communicationList,
        ...this.communicationList
      ];
    },
    async getSoftList() {
      this.softLoadingMore = true;
      let resume_id = this.resume.id;
      this.softPage = this.softPage + 1;
      let params = {
        page: this.softPage,
        limit: 3,
        resume_id
      };
      let { list: softList, total } = await Api.resume.getSoftSkillList(params);
      this.softLoadingMore = false;

      softList = this.handleSoftList(softList);
      this.softList = [...this.softList, ...softList];
      this.showSoftLoadingMore = total > this.softPage * 3 ? true : false;
    },
    async updateSoft() {
      this.softLoadingMore = true;
      let resume_id = this.resume.id;
      let params = {
        page: 1,
        limit: 1,
        resume_id
      };
      let { list: softList } = await Api.resume.getSoftSkillList(params);
      this.softLoadingMore = false;

      softList = this.handleSoftList(softList);
      this.softList = [...softList, ...this.softList];
    },
    handleSoftList(softList) {
      softList.forEach(soft => {
        soft.extra = soft.extra || [];
        soft.soft = soft.soft || [];
        let arr = soft.tags.split(",");
        arr.forEach(item => {
          item.indexOf(":") == -1
            ? soft.extra.push(item)
            : soft.soft.push(item);
        });
      });
      return softList;
    }
  }
};
</script>
<style lang="scss"></style>
